import { AddCircleIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { PoolButton as PoolButtonHeader } from '@synergy/components';
import { PoolDocumentTitle, RouteTab, RouteTabs } from '@synergy/components-next';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';

import { AddSupplierModal } from './suppliers/import-overview-add-supplier.modal';
import { ImportOverviewAll } from './all/import-overview-all';
import { ImportOverviewFilter } from '../components/import-overview-filter';
import { ImportOverviewSuppliers } from './suppliers/import-overview-suppliers';
import { ImportSupplierFilter } from './suppliers/import-supplier-filter';
import { ImportTabs } from '../models/import-tabs';
import { PaloOverview } from '../../../../common/components/palo/palo-overview';
import { defaultSearchParamsSelector } from '../../../../store/default-searchparams-selector';
import { resetImports } from '../store/all/import-actions';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

export const ImportOverview = () => {
    const location = useLocation();
    const dispatch = useThunkDispatch();
    const defaultSearchParams = useAppSelector(defaultSearchParamsSelector);
    const [searchParams, setSearchParams] = useSearchParams(defaultSearchParams);
    const [isOpenAddSupplier, setIsOpenAddSupplier] = useState<boolean>(false);
    const currentTab = (location.pathname.split('/').pop() as ImportTabs) ?? ImportTabs.All;

    return (
        <PaloOverview
            titleMessage={<FormattedMessage id="app.navigation.import" />}
            pathname={location.pathname}
            onResetData={() => dispatch(resetImports())}
            filters={currentTab === ImportTabs.All ? <ImportOverviewFilter /> : <ImportSupplierFilter />}
            defaultSearchParams={defaultSearchParams}
            tabs={
                <RouteTabs tabs={ImportTabs} indicatorColor="primary">
                    <RouteTab
                        value={ImportTabs.All}
                        label={<FormattedMessage id="app.imports.tabs.all" />}
                        searchParams={defaultSearchParams}
                    />
                    <RouteTab
                        value={ImportTabs.Suppliers}
                        label={<FormattedMessage id="app.imports.tabs.suppliers" />}
                        searchParams={defaultSearchParams}
                    />
                </RouteTabs>
            }
            additionalItemsLeft={[
                currentTab === ImportTabs.Suppliers && (
                    <PoolButtonHeader
                        startIcon={<AddCircleIcon />}
                        key="back"
                        styleType="toolbar"
                        onClick={() => setIsOpenAddSupplier(true)}
                    >
                        <FormattedMessage id="app.imports.suppliers.addSupplier" />
                    </PoolButtonHeader>
                ),
            ]}
        >
            <PoolDocumentTitle titleTranslationId={'app.navigation.import'} />
            <Routes>
                <Route path={ImportTabs.All} element={<ImportOverviewAll />} />
                <Route path={ImportTabs.Suppliers} element={<ImportOverviewSuppliers />} />
                <Route path="*" element={<Navigate to={{ pathname: ImportTabs.All }} replace={true} />} />
            </Routes>
            <AddSupplierModal
                open={isOpenAddSupplier}
                importSupplier={null}
                onClose={() => setIsOpenAddSupplier(false)}
            />
        </PaloOverview>
    );
};
